<script lang="ts">
	import type { SplittedAddress } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';
	import PoiSummaryTemplate from '../PoiSummaryTemplate.svelte';

	export let name: string;
	export let address: SplittedAddress | null = null;
	export let bookUrl: string | null = null;

	const color = 'parking';

	const dispatch = createEventDispatcher<{
		addClick: void;
		bookClick: void;
	}>();
</script>

<PoiSummaryTemplate {name} {color}>
	<svelte:fragment slot="infos">
		{#if address !== null}
			<div><span class="truncate">{address.firstLine}</span></div>
			<div class="mb-1"><span class="truncate">{address.secondLine}</span></div>
		{/if}
	</svelte:fragment>
	<svelte:fragment slot="buttons">
		{#if bookUrl !== null}
			<Link
				button="filled"
				color="primary"
				size="sm"
				icon="shopping-cart"
				label={m.poi_actions__book()}
				href={bookUrl}
				target="_blank"
				rel="external"
				onclick={() => dispatch('bookClick')}
			/>
			<ButtonAddToItinerary
				size="sm"
				variant="outline"
				onclick={() => dispatch('addClick')}
			/>
		{:else}
			<ButtonAddToItinerary
				size="sm"
				onclick={() => dispatch('addClick')}
			/>
		{/if}
	</svelte:fragment>
</PoiSummaryTemplate>
